export default __webpack_public_path__ + "static/media/emptyState.e42efc5d.svg";